/** Языки с отдельным OG-превью по пути /{code} (см. scripts/og-locales.json). */
export const OG_PATH_LOCALES = new Set(["ru"]);

const OG_PATH_RE = /^\/([a-z]{2})(?:\/|$)/;

export function getPathLocale(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  const match = window.location.pathname.match(OG_PATH_RE);
  if (!match) {
    return null;
  }
  const code = match[1].toLowerCase();
  return OG_PATH_LOCALES.has(code) ? code : null;
}
